export enum ClientSupportMediumStatus {
    All = 0,
    Active = 1,
    Deleted = 2,
}
